function ModalConfirmContent({ ...other }) {
  return { ...other };
}

export default ModalConfirmContent;
